function nunjucks_filter_defaults()
{
    this.isAsync = false;
    this.name = 'defaults';
    this.filter = function(opts, defaults)
    {
        for (var k in defaults) {
            if (typeof opts[k] === 'undefined') {
                opts[k] = defaults[k];
            }
        }
        return opts;
    };
}
